import FormikInputGroup from 'components/formikFields/inputGroup';
import UploadImageEdit from 'components/uploadImageEdit';

interface EditQualityFormComponentProps extends IQualityFormComponentProps {
  oldImages?: Array<IImage>;
  mainImageGuid: string;
  removeImage: (item: string) => void;
}
const EditQualityFormComponent = ({
  setImages,
  images,
  oldImages,
  existingUnits,
  mainImageGuid,
  removeImage,
}: EditQualityFormComponentProps) => {
  return (
    <>
      <div className="mt-8 px-3">
        <UploadImageEdit
          mainImageGuid={mainImageGuid}
          oldImages={oldImages}
          images={images}
          setImages={setImages}
          removeImage={removeImage}
        />
      </div>
      <div className="mt-8">
        <FormikInputGroup
          name="existing"
          label="موجودی"
          required
          Options={existingUnits}
          optionName="existing_unit"
        />
      </div>
      <div className="mt-8">
        <button
          type="submit"
          className=" w-full text-white bg-primary py-4 rounded-lg mb-6"
        >
          ادامه
        </button>
      </div>
    </>
  );
};

export default EditQualityFormComponent;
